/**
 * Firm Store — Single source of truth for all firm data on the frontend.
 * Fetches ALL firms (internal + external) from /api/firms/all on app init.
 * Provides synchronous getters for cached data.
 */
import { API } from "./constants";
import { fetchWithRetry } from "./fetchRetry";
import { logger } from "./logger";

let _firmCache = {};        // slug → firm object
let _allFirms = [];         // ordered array
let _ready = false;
let _initPromise = null;

export async function initFirmStore() {
  if (_initPromise) return _initPromise;
  _initPromise = _doInit();
  return _initPromise;
}

async function _doInit() {
  try {
    const res = await fetchWithRetry(`${API}/firms/all`);
    if (!res.ok) throw new Error(`firms/all ${res.status}`);
    const firms = await res.json();
    _allFirms = firms;
    _firmCache = {};
    for (const f of firms) {
      _firmCache[f.slug] = f;
    }
    _ready = true;
  } catch (err) {
    logger.warn("firmStore: failed to init from API", err);
  }
}

/** Get a single firm by slug (sync — returns null if not cached) */
export function getCachedFirm(slug) {
  return _firmCache[slug] || null;
}

/** Get all cached firms */
export function getAllCachedFirms() {
  return _allFirms;
}

/** Check if the store has loaded */
export function isFirmStoreReady() {
  return _ready;
}

/** Check if a slug is a known firm */
export function isKnownFirm(slug) {
  return slug in _firmCache;
}
